import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const JobTitles = () => {

    const JobConfigs: MasterConfigs = {
        api: () => '/job-titles',
        title: 'Job Title',
        isActionTab: true,
        modalTitle: (action) => `${action} ${JobConfigs.title}`,
        getColumns: () => {
            return [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: 'Department',
                    dataIndex: 'department',
                    key: 'department',
                    render: (department) => {
                        return department && department.name;
                    },
                },
                {
                    title: 'Created On',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    width: 150,
                    render: (date) => {
                        return new Date(date).toDateString();
                    }
                },
            ];
        },
        getFormColumns: () => {
            return [
                {
                    label: 'Name',
                    name: 'name',
                    type: 'text',
                    rules: [{ required: true, message: 'Name is required' }],
                },
                {
                    label: 'Department',
                    name: 'department',
                    isCombo: true,
                    type: 'select',
                    rules: [{ required: true, message: 'Department is required' }],
                },
                {
                    label: 'Description',
                    name: 'description',
                    type: 'textarea',
                    span: 16
                },
            ];
        },
        combo: [
            {
                name: 'department',
                api: '/departments',
                idKey: '_id',
                render: (e) => e.name
            },
        ],
        actions: [
            { name: 'Add Job Title', actionType: 'Add' }
        ],
    };

    return (
        <MasterComponent config={JobConfigs} />
    );
}

export default JobTitles;